import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import englishFlag from "../Assets/images/eng_flag.png";
import spainFlag from "../Assets/images/spain.png";
import { routeConfig } from "../i18nWrapper/Routes";
import { matchPath } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../Reducer/homeReducer";

const languages = [
  {
    code: "en",
    label: "English",
    flag: englishFlag,
  },
  {
    code: "es",
    label: "Español",
    flag: spainFlag,
  },
];

const LanguageSwitcher = () => {
  const language = useSelector((state) => state.persistedReducer.home.language);
  const { i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState(language);
  const dropdownRef = useRef();
  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
      setSelectedLang(language);
    }
  }, [language]);

  const changeLanguagehandle = (lang) => {
    const supportedLangs = ["en", "es"];

    // Detect current language
    const currentLang = location.pathname.split("/")[1];

    // Remove language prefix
    const currentPath =
      location.pathname.replace(
        new RegExp(`^\/(${supportedLangs.join("|")})`),
        "",
      ) || "/";

    let matchedRoute = null;
    let routeParams = {};

    for (let route of routeConfig) {
      const pattern = route[currentLang];

      const match = matchPath(currentPath, {
        path: pattern,
        exact: route.exact !== false,
        strict: false,
      });

      if (match) {
        matchedRoute = route;
        routeParams = match.params;
        break;
      }
    }

    let newPath = "/";

    if (matchedRoute) {
      let targetPattern = matchedRoute[lang];

      // Replace dynamic params
      Object.keys(routeParams).forEach((key) => {
        targetPattern = targetPattern.replace(`:${key}`, routeParams[key]);
      });

      newPath = targetPattern;
    }

    history.push(`/${lang}${newPath}`);

    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    dispatch(setLanguage(lang))
    setSelectedLang(lang);
    setIsOpen(false);
  };

  // ⭐ Close dropdown outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!dropdownRef.current?.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ⭐ Sync selected language with URL
  // useEffect(() => {
  //   const seg = location.pathname.split("/")[1];
  //   if (seg === "es" || seg === "en") {
  //     setSelectedLang(seg);
  //   }
  // }, [location.pathname]);

  const selectedLanguage = languages.find((l) => l.code === selectedLang);

  return (
    <div
      className="language-dropdown"
      ref={dropdownRef}
      style={{ position: "relative" }}
    >
      {/* Selected Language Button */}
      <button
        className="dropdown-toggle golden-btn"
        onClick={() => setIsOpen(!isOpen)}
        style={{ display: "block", alignItems: "center", gap: "6px" }}
      >
        <img
          src={selectedLanguage?.flag}
          alt={selectedLanguage?.label}
          width="20"
        />
        {selectedLanguage?.label}
      </button>

      {/* Dropdown */}
      {isOpen && (
        <ul className="dropdown-menu langData">
          {languages.map((lang) => (
            <li
              key={lang?.code}
              onClick={() => changeLanguagehandle(lang?.code)}
              className={`lang-item ${
                selectedLang === lang?.code ? "active-lang" : ""
              }`}
            >
              <img src={lang?.flag} alt={lang?.label} width="20" />
              {lang?.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
